export enum RouteURLs {
    Home = '/',
    HowToUse = '/how-to-use',
    Blog = '/blog',
    AboutUs = '/about-us',
    PrivacyPolicy = '/privacy-policy',
    TermsOfService = '/terms-of-service',
    AddToChrome = 'https://chrome.google.com/webstore/detail/mmhpmbmabmppoeonpcclfiobhpjdcdjc',
    AddToEdge = 'https://microsoftedge.microsoft.com/addons/detail/bjnffbkjlacbalfjbajpomeoigkfabdp',
}